import { render } from "./EnbMarketingGeral.vue?vue&type=template&id=95740350&scoped=true"
import script from "./EnbMarketingGeral.vue?vue&type=script&lang=js"
export * from "./EnbMarketingGeral.vue?vue&type=script&lang=js"

import "./EnbMarketingGeral.vue?vue&type=style&index=0&id=95740350&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95740350"]])

export default __exports__